import React from 'react'
import {
  Icon,
  Segment,
  Table,
  Button,
  Input,
  Label,
  Popup,
  Message
} from 'semantic-ui-react'

function getChoiceFor(type, eid, cid) {
  const e = type.find(e=>e.id===eid);
  const c = e.choices.find(c=>c.id===cid);
  return c;
}

function hasDuplicateEnumIds(type) {
  const eids = type.map(e=>e.id);
  return eids.length>new Set(eids).size;
}

const TypeEditorExampleSelector = ({type, exampleItem, onToggleExampleItem}) => {
  return (
    <Segment secondary>
      <p>Click the buttons to test your selection type.</p>
      <Table compact='very' basic='very'>
      <Table.Body>
      <Table.Row>
      <Table.Cell collapsing>
      {
        type.map((e,ei)=>
          <span key={ei}>
            <Button.Group>
              {
                e.choices.map((c,ci)=>
                  <Popup
                    key={ci}
                    trigger={
                      <Button
                        key={ci}
                        type='button'
                        compact
                        icon
                        color={exampleItem[e.id]===c.id?c.color:null}
                        onClick={()=>onToggleExampleItem(e.id, c.id)}
                      >
                        <Icon name={c.icon}/>
                      </Button>
                    }
                    content={
                      <span>
                        <strong>{e.name}:</strong> {c.name}
                        <p style={{fontSize: '80%'}}>
                          <span style={{color: 'grey'}}>{c.description}</span>
                        </p>
                      </span>
                    }
                  />
                )
              }
            </Button.Group>
            {' '}
          </span>
        )
      }
      </Table.Cell>
      <Table.Cell>
      <Input
        label='JSON'
        fluid
        disabled
        value={JSON.stringify(exampleItem)}
      />
      </Table.Cell>
      </Table.Row>
      </Table.Body>
      </Table>
      {
        hasDuplicateEnumIds(type)
        ?
          <Message negative>
            <p>Duplicate enumeration Ids</p>
          </Message>
        :
          <Table definition compact='very'>
            <Table.Body>
              {
                type.map((e,ei)=>
                  <Table.Row key={ei}>
                    <Table.Cell collapsing>
                      {e.name}
                    </Table.Cell>
                    <Table.Cell>
                      {
                        exampleItem[e.id]
                        ?
                        <Label color={getChoiceFor(type, e.id, exampleItem[e.id]).color}>
                          <Icon name={getChoiceFor(type, e.id, exampleItem[e.id]).icon}/>
                          {getChoiceFor(type, e.id, exampleItem[e.id]).name}
                        </Label>
                        :
                        <Label>
                          <i>not set</i>
                        </Label>
                      }
                    </Table.Cell>
                  </Table.Row>
                )
              }
            </Table.Body>
          </Table>
      }
    </Segment>
  );
}

export default TypeEditorExampleSelector